'use client';

import { UserResponse } from '@/types/user';
import { atom } from 'jotai';

export const DEFAULT_PROFILE_PICTURE =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiIGZpbGw9IiMyMzI3M2EiLz48Y2lyY2xlIGN4PSI2NCIgY3k9IjQ4IiByPSIyNCIgZmlsbD0iI2I0YjRjYyIvPjxwYXRoIGQ9Ik0yNCAxMDhDNDAgODggODggODggMTA0IDEwOEgyNFoiIGZpbGw9IiNiNGI0Y2MiLz48L3N2Zz4=';

export const userAtom = atom<UserResponse | null>(null);
